import gql from 'graphql-tag'

export const SHIPPING_LINES_QUERY = gql`
query CruiseCompassShippingLines{
  shippingLines{
    results{
        id
        name
    }
  }
}
`
